import CardTable from 'components/CardTable/CardTable'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from "@mui/icons-material/Add";
import { Description } from '@mui/icons-material'
import { ColumnContainer } from 'utils/columnsStyle';
import { columns } from './columns'
import {
  setStationMunicipalitiesFilters,
  getStationMunicipalities,
  deleteStationMunicipalities,
  getStatesWithMunicipalities,
} from 'redux/actions/stationMunicipalities/stationMunicipalitiesActions'
import RegularButton from 'components/CustomButtons/Button'
import { useSearch } from 'hooks/useSearch'
import { ModalV2 } from 'components/Modal/ModalV2'
import { TableInputs } from 'components/CardTable/TableInputs'
import { FormStationMunicipalitiesEdit } from './FormStationMunicipalitiesEdit'
import { useTableStationMunicipalitiesConfig } from "./hooks";
import { useToggle } from 'hooks/useToggle'

const style = {
  color: '#004F9F',
  fontSize: 20,
  marginRight: 10,
  cursor: 'pointer'
}

export const StationMunicipalities = () => {
  const { setSnackbar, buildCompLoadings } = useSearch();
  const { rules } = useSelector(({ login }) => login)
  const { station, stationMunArr, config } = useSelector(({ stationMun }) => stationMun)
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { page, pageSize, sorted, filtered } = config;
  const {
    handleFilter,
    handlePage,
    handlePageSize,
    handleSort,
  } = useTableStationMunicipalitiesConfig();
  const [submitted, setSubmitted] = useState(false)
  const [isOpenNew, handleIsOpenNew] = useToggle();
  const [newColumns, setNewColumns] = useState(columns)
  const dispatch = useDispatch()

  const handleSubmit = useCallback(() => {
    if (!station?.id) {
      setSnackbar("No se ha seleccionado alguna planta.");
      return;
    }
    dispatch(getStationMunicipalities(station.id));
    setSubmitted(true);
  }, [station]);

  // Effects
  useEffect(() => {
    const isEmpty = stationMunArr.length === 0
    if (isEmpty && submitted) {
      setSnackbar("No se encontraron datos");
    }
    setSubmitted(false);
    // eslint-disable-next-line
  }, [stationMunArr])

  useEffect(() => {
    buildCompLoadings(["loadingStationMunicipalities"]);
    dispatch(getStatesWithMunicipalities())

    if(rules.includes('SUPPORT-MUNICIPALITIES-DELETE')) {
      setNewColumns([
        ...columns,
        {
          Header: "Acciones",
          filterable: false,
          sortable: false,
          Cell: ({ original }) => {
            const [isOpenDelete, handleIsOpenDelete] = useToggle();

            const handleDelete = () => dispatch(deleteStationMunicipalities({
              ...original,
              idStation: original.idStation, 
              idMunicipality: original.id
            }))

            return (
              <>
                <ColumnContainer>
                  <DeleteIcon style={{ ...style,  color: '#e83737'}} onClick={handleIsOpenDelete}/>
                </ColumnContainer>
                <ModalV2
                  open={isOpenDelete}
                  onClose={handleIsOpenDelete}
                  title={`¿Estas seguro que desea eliminar el Municipio 
                    "${original.name}" de la Planta "${original.station}"?`.toUpperCase()}
                  minHeight={2}
                  textAlign="center"
                  textMargin={28}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 8,
                      marginTop: 32,
                    }}
                  >
                    <RegularButton onClick={handleIsOpenDelete} color="info">
                      Cancelar
                    </RegularButton>
                    <RegularButton onClick={handleDelete} color="danger">
                      Eliminar
                    </RegularButton>
                  </div>
                </ModalV2>
              </>
            )
          },
        }
      ])
    }
    // eslint-disable-next-line
  }, []);
  
  return (
    <React.Fragment>
      <CardTable
        hasHeader
        title="Municipios por Planta"
        icon={<Description />}
        data={stationMunArr}
        columns={newColumns}
        isLoading={isLoadingComp?.loadingStationMunicipalities}
        blockBtn
        hasControl
        controls={
          <RegularButton round justIcon color="info" style={{ margin: 10 }} onClick={handleIsOpenNew}>
            <AddIcon style={{ margin: 0 }}/>
          </RegularButton>
        }
        tableContent={
          <TableInputs
            reducer="stationMun"
            stations
            dispatchAction={setStationMunicipalitiesFilters}
            loading={isLoadingComp?.loadingStationMunicipalities}
            submitAction={handleSubmit}
          />
        }
        page={page}
        pageSize={pageSize}
        sorted={sorted}
        filtered={filtered}
        onFilteredChange={handleFilter}
        onPageSizeChange={handlePageSize}
        onPageChange={handlePage}
        onSortedChange={handleSort}
      />
      <ModalV2
        open={isOpenNew}
        title={'Agregar municipio'} 
        toRight
        onClose={handleIsOpenNew}
        style={{ 
          'div': {
            border: '5px solid red', margin: 50
          }
        }}
      >
        <FormStationMunicipalitiesEdit handleClose={handleIsOpenNew}/>
      </ModalV2>
    </React.Fragment>
  )
}
